import { useEffect, useRef, useState } from 'react';
import { TimeClock16 } from 'ui/icons/aurora/16px/TimeClock16';
import { noop } from 'utils/noop';
import { displayTime, formatTime, setTime } from 'utils/time';
import { TIME_PLACEHOLDER, selectInputText } from '../helpers';
import { InputWrapper, StyledTimeInput } from './DatePickerInput.styles';

// export type TimeInputProps = {
//   /** Unique id of input */
//   id: string,
//   /** Whether input is disabled */
//   isDisabled?: boolean,
//   /** Whether date range is invalid */
//   isInvalidRange?: boolean,
//   /** Whether input is read only */
//   isReadOnly?: boolean,
//   /** Function run when entry is changed (for internal use) */
//   onEntryChange?: () => void,
//   /** Function to be run when the time is updated */
//   onTimeChange?: (moment) => void,
//   /** Time to display */
//   time: moment,
//   /** A timezone such as America/Los_Angeles */
//   timeZone?: string,
// };
/**
 * TimeInput
 * @param {any} id
 * @param {boolean=} isDisabled
 * @param {boolean=} isInvalidRange
 * @param {boolean=} isReadOnly
 * @param {() => void=} onEntryChange
 * @param {() => void=} onTimeChange
 * @param {an} time
 * @param {any=} timeZone
 */
export const TimeInput = ({
  id,
  isDisabled = false,
  isInvalidRange,
  isReadOnly = false,
  onEntryChange = noop,
  onTimeChange = noop,
  time,
  timeZone = null,
}) => {
  const inputRef = useRef(null);
  const [value, setValue] = useState(displayTime(time, false, false, timeZone));
  const [isValid, setIsValid] = useState(true);
  const [isFocused, setIsFocused] = useState(false);
  const validateTime = () => {
    const formattedTime = formatTime(value);
    const checkIsValid = formattedTime !== 'invalid';
    if (checkIsValid) {
      setValue(formattedTime);
      onTimeChange(setTime(time, formattedTime));
    }
    setIsValid(checkIsValid);
    onEntryChange({ [id]: checkIsValid });
    setIsFocused(false);
  };
  const handleFocus = () => {
    selectInputText(inputRef);
    setIsFocused(true);
  };
  useEffect(() => setValue(displayTime(time, false, false, timeZone)), [time]);
  return (
    <InputWrapper
      isValid={isValid && !isInvalidRange}
      isFocused={isFocused}
      isDisabled={isDisabled || isReadOnly}
    >
      <TimeClock16 />
      <StyledTimeInput
        data-test={`${id}${isValid ? '' : '-invalid'}`}
        id={id}
        isDisabled={isDisabled}
        onBlur={isReadOnly ? () => setIsFocused(false) : validateTime}
        onChange={(e) => setValue(e.target.value)}
        onFocus={handleFocus}
        placeholder={TIME_PLACEHOLDER}
        readOnly={isDisabled || isReadOnly}
        ref={inputRef}
        tabIndex={0}
        type="text"
        value={time ? value : TIME_PLACEHOLDER}
        withTimeZone={Boolean(timeZone)}
      />
    </InputWrapper>
  );
};
